export default {
  title: "Admin Dashboard",

  titles: {
    adminPanel: "Admin panel",
    creditDistribution: "Credit Distribution",
    financialOverview: "Credit Overview",
    members: "Members",
    addMember: "Add Member",
    bulkUpload: "Adding Members",
    csvUploadMembers: "Add Existing Members to Group",
    groups: "Groups",
    noGroups: "No groups yet",
    unknownEntity: "Unknown entity",
    organization: "Organization",
    group: "Group",
    ofGroup: "of group",
    ofOrganization: "of organization",
  },

  statistics: {
    usedCredits: "Used credits",
    distributedCredits: "Distributed credits",
    remainingDistributed: "Remaining distributed",
    unassignedCredits: "Unassigned credits",
    totalCredits: "Total credits",
  },

  search: {
    placeholder: "Search members...",
    groupsPlaceholder: "Search groups...",
  },

  table: {
    headers: {
      name: "Name",
      lastName: "Last Name",
      createdAt: "Created",
      groupName: "Group Name",
      groupDescription: "Group Description",
      members: "Members",
      learningPaths: "Courses",
      aiProfiles: "Model Situations",
      allowSubgroups: "Allow Subgroups",
      email: "Email",
      role: "Role",
      credits: "Credits",
      used: "Used Cr.",
      startedJourneys: "Started Journeys",
      finishedJourneys: "Finished Journeys",
      limit: "Credit Limit for Distribution",
      actions: "Actions",
      creditsPerOrganization: "Remaining Credits",
      usedCreditsPerOrganization: "Used Credits",
      memberSelectPlaceholder: "Members Select",
      searchPlaceholder: "Search...",
      learningPathsPlaceholder: "Courses Select",
      aiProfilesPlaceholder: "Model Situations Select",
      addDescriptionPlaceholder: "Add description",
      user: "User",
      groups: "Groups",
    },
    roles: {
      admin: "Admin",
      manager: "Manager",
      employee: "Employee",
    },
    actions: {
      edit: "Edit",
      delete: "Delete",
      save: "Save Changes",
      saveGroupChanges: "Save Group Changes",
      add: "Add",
      close: "Close",
      bulkUpload: "Upload via CSV",
      upload: "Upload",
      uploadCsv: "Upload CSV",
      addToGroup: "Add to Group",
      createGroup: "Create Group",
      createSubgroup: "Create Subgroup",
      openInNewTab: "Open group in new tab",
      expand: "Expand subgroups",
      collapse: "Collapse subgroups",
      deleteMemberFromGroup: "Remove Member from Group",
      deleteMemberFromOrg: "Remove Member from Organization",
      copySetupLink: "Copy password setup link",
    },
  },

  bulkUpload: {
    globalGroupSelection: "Apply Groups to All members",
    globalGroupDescription: "Select groups that will be applied to all members being uploaded. You can still modify individual member groups below.",
    selectGroups: "Select groups...",
    selectGroupsForAll: "Select Groups for All members",
    selectUserGroups: "Select groups",
    groupsFor: "Groups for",
    noGroupsAvailable: "No groups available",
    globalCreditsSelection: "Apply Credits to All Members",
    availableCredits: "Available Credits",
    creditsPerUser: "Credits per User",
    creditsPlaceholder: "Enter credits amount...",
    totalNeeded: "Total",
    existingCreditsInfo: "Currently assigned: {credits} credits",
    existingCreditsTooltip: "If you enter a lower value, the difference will be returned to the organization's unassigned credits.",
  },

  inputs: {
    newMember: {
      email: "Email",
      firstName: "Name",
      lastName: "Last Name",
      title: "Title",
      subTitle: "Sub Title",
      phone: "Phone",
      memberDescription: "Description",
      dateOfBirth: "Date of Birth",
      position: "Position",
      memberImage: "Image",
    },
  },

  messages: {
    memberAddSuccess: "Member was successfully added.",
    setupLinkCopied: "The password setup link was copied to the clipboard. Note: previously issued links stop working.",
    setupLinkCopyManual: "Copy failed, please copy the link manually: {link}",
    setupLinkCopyFail: "Could not generate the setup link.",
    memberAddSuccessEmailFail: "Member was added, but the e-mail with the link could not be sent. You can re-send it in User management.",
    memberAddFail: "Member could not be added.",
    memberEditSuccess: "Member was successfully edited.",
    memberEditFail: "Member could not be edited.",
    memberDeleteSuccess: "Member was successfully removed.",
    memberDeleteFail: "Member could not be removed.",
    memberMarkedForDeletion: "Member marked for deletion. Click 'Save Changes' to confirm.",
    changesSaved: "Changes were successfully saved.",
    changesNotSaved: "Changes could not be saved.",
    bulkUploadSuccess: "Members were successfully added.",
    bulkUploadSomeFailed: "Some members could not be added ({count}).",
    bulkUploadEmailFail: "The e-mail with the link could not be sent to some members ({count}) - it can be re-sent in User management.",
    bulkUploadFail: "Members could not be added.",
    unsaveChanges: "You have unsaved changes. Are you sure you want to leave?",
    missingMemberData: "Some fields are not filled in. Please fill in all required fields.",
    correctCsvFormat: "The CSV file must be in the following format and it must have only 3 columns with these names: firstName | lastName | email",
    wrongCsvFormat: "CSV file is not in the correct format, it must have only 3 columns with these names: firstName | lastName | email",
    notEnoughCredits: "You do not have enough credits for this action.",
    invalidCredits: "Invalid credits value.",
    deleteGroup: "Are you sure you want to delete this group {name}?",
    groupDeleteSuccess: "Group was successfully removed.",
    groupDeleteFail: "Group could not be removed.",
    saveBeforeNavigation: "Please save your changes before opening a group in a new tab.",
    csvUsersPreview: "Found {count} valid users in the CSV file:",
    csvMembersAddedToGroup: "Successfully added {count} members to group '{groupName}'",
    csvMembersAlsoAddedToParents: " (also added to {parentCount} parent group(s))",
    csvUploadFailed: "Failed to add members to group",
    csvUsersNotFound: "The following users were not found in the organization: {emails}",
    noValidUsersFound: "No valid existing users found in the CSV file",
    subgroupsNotAllowed: "This group does not allow creating subgroups",
    subgroupCreated: "Subgroup successfully created under '{parentName}'",
    subgroupCreationFailed: "Failed to create subgroup",
    deleteMember: "Are you sure you want to delete this member: {email}?",
  },
};
